<template>
    <el-button type="success" @click="handleButtonClick" :disabled="disabled" size="large" :class="classes" height="40">
        <i :class="'fa-solid fa-' + icon + 'pr-2'"></i>
        <div class="pl-1">{{ label }}</div>
    </el-button>
</template>

<script>
    export default {
        props: {
            classes: {
                type: Object,
                default: null,
            },
            label: {
                type: String,
                default: 'Select',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                default: 'secondary',
            },
            icon: {
                type: String,
                default: 'check-circle',
            },
        },
        methods: {
            handleButtonClick(event) {
                this.$emit('click-self', event)
            },
        },
    }
</script>
